import { render, staticRenderFns } from "./HighlightedReviewsSlider.vue?vue&type=template&id=72b916ad&scoped=true&"
import script from "./HighlightedReviewsSlider.vue?vue&type=script&setup=true&lang=js&"
export * from "./HighlightedReviewsSlider.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./HighlightedReviewsSlider.vue?vue&type=style&index=0&id=72b916ad&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b916ad",
  null
  
)

export default component.exports